import React, { useState, useEffect } from 'react';
import {
    Box, Typography, TextField, MenuItem, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, IconButton, LinearProgress, Tabs, Tab, Button
} from '@mui/material';
import { FaEdit } from 'react-icons/fa';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';
import Stockmercadorias from './Stockmercadorias';
import { useNavigate } from 'react-router-dom';

const apiBaseURL = 'https://plasticemployers.duckdns.org';

axios.defaults.baseURL = apiBaseURL;
axios.defaults.withCredentials = true;

const colorIdMap = {
    "Branco": 1,
    "Castanho": 2,
    "Verde": 3,
    "Laranja": 4,
    "Azul Escuro": 5,
    "Azul Claro": 6,
    "Amarelo": 7,
    "Rosa": 8,
    "Preto": 9,
    "Vermelho": 10
};

const sizeIdMap = {
    "18x8x24": 1,
    "22x10x28": 2,
    "24x11x32": 3,
    "28x11x32": 4,
    "32x11x42": 5,
    "35x16x44": 6,
    "42x16x49": 7,
    "28x11x22": 8,
    "32x11x28": 9,
    "40x11x32": 10,
    "42x16x34": 11,
    "52x16x42": 12,
    "52x16x49": 13,
    "27x16x31": 14,
    "31x20x32": 15,
    "18x8x39": 26
};

const productIdMap = {
    "ATB1882490": 1,
    "ATB22102890": 3,
    "ATB24113290": 4,
    "ATB28113290": 5,
    "ATB321142100": 6,
    "ATB421649110": 8,
    "ATB28112290": 9,
    "ATB321128100": 12,
    "ATB401132100": 13,
    "ATB421634110": 14,
    "ATB521642110": 15,
    "ATB521649110": 17,
    "ATB271631100": 18,
    "ATB312032100": 19,
    "ATB1883990": 21,
    "ATC18824115": 22,
    "ATC221028115": 23,
    "ATC241132115": 24,
    "ATC281132115": 25,
    "ATC321142115": 26,
    "ATC351644115": 27,
    "ATC421649115": 28,
    "ATC281122115": 29,
    "ATC321128115": 30,
    "ATC401132115": 31,
    "ATC421634115": 32,
    "ATC521642115": 33,
    "ATC521649115": 34,
    "ATC271631115": 35,
    "ATC312032115": 36,
    "ATC18839115": 37,
    "ATB121882490": 38,
    "ATB991882490": 39,
    "ATB151882490": 40,
    "ATB131882490": 41,
    "ATB031882490": 42,
    "ATB111882490": 43,
    "ATB191882490": 44,
    "ATB101882490": 45,
    "ATB1022102890": 46,
    "ATB1922102890": 47,
    "ATB1122102890": 48,
    "ATB0322102890": 49,
    "ATB1322102890": 50,
    "ATB1522102890": 51,
    "ATB9922102890": 52,
    "ATB1222102890": 53,
    "ATB1224113290": 54,
    "ATB9924113290": 55,
    "ATB1524113290": 56,
    "ATB1324113290": 57,
    "ATB0324113290": 58,
    "ATB1124113290": 59,
    "ATB1924113290": 60,
    "ATB1024113290": 61,
    "ATB1028113290": 62,
    "ATB1928113290": 63,
    "ATB1128113290": 64,
    "ATB0328113290": 65,
    "ATB1328113290": 66,
    "ATB1528113290": 67,
    "ATB9928113290": 68,
    "ATB1228113290": 69,
    "ATB12321142100": 70,
    "ATB99321142100": 71,
    "ATB15321142100": 72,
    "ATB13321142100": 73,
    "ATB03321142100": 74,
    "ATB11321142100": 75,
    "ATB19321142100": 76,
    "ATB10321142100": 77,
    "ATB10421649110": 78,
    "ATB19421649110": 79,
    "ATB11421649110": 80,
    "ATB03421649110": 81,
    "ATB13421649110": 82,
    "ATB15421649110": 83,
    "ATB99421649110": 84,
    "ATB12421649110": 85,
    "ATB19321128100": 86,
    "ATB191883990": 87,
    "ATB19401132100": 88
};

const Stocks = () => {
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [articles, setArticles] = useState([]);
    const [selectedColor, setSelectedColor] = useState('');
    const [selectedSize, setSelectedSize] = useState('');
    const [stockLimits, setStockLimits] = useState({}); // Adiciona o estado para limites de estoque
    const [tabIndex, setTabIndex] = useState(0);
    const navigate = useNavigate();


    useEffect(() => {
        fetchColors();
        fetchAllSizes(); // Adiciona todos os tamanhos inicialmente
    }, []);

    const fetchColors = async () => {
        try {
            const response = await axios.get('/api/cores/');
            setColors(response.data);
        } catch (error) {
            console.error('Erro ao buscar cores:', error);
        }
    };

    const fetchAllSizes = async () => {
        try {
            const response = await axios.get('/api/tamanhos/');
            const formattedSizes = response.data.map((size) => ({
                id: size,  // Usa o nome como id
                nome: size // Define o próprio nome do tamanho
            }));
            console.log("Todos os tamanhos formatados para dropdown:", formattedSizes); // Log para depuração
            setSizes(formattedSizes);
        } catch (error) {
            console.error('Erro ao buscar todos os tamanhos:', error);
        }
    };
    
    const fetchArticlesByColorAndSize = async (colorId, sizeId) => {
        try {
            // Construção da URL com query strings para múltiplos IDs de cores e tamanhos
            const allColorIds = colorId === "all" ? colors.map(color => colorIdMap[color]).filter(Boolean).join(',') : colorId;
            const allSizeIds = sizeId === "all" ? sizes.map(size => sizeIdMap[size.nome]).filter(Boolean).join(',') : sizeId;
            
            // URL com parâmetros de query
            const url = `/api/artigos/?colors=${allColorIds}&sizes=${allSizeIds}`;
    
            const response = await axios.get(url);
            
            // Exibe os artigos no console
            console.log("Artigos retornados:", response.data);
            
            setArticles(response.data);
        } catch (error) {
            console.error('Erro ao buscar artigos para cor e tamanho:', error);
        }
    };

    const fetchSizesByColor = async (colorId) => {
        try {
            const response = await axios.get(`/api/tamanhos/${colorId}/`);
            const formattedSizes = response.data.map((size) => ({
                id: size,  // Usa o nome como id
                nome: size // Define o próprio nome do tamanho
            }));
            console.log("Tamanhos formatados para dropdown:", formattedSizes); // Log para depuração
            setSizes(formattedSizes);
        } catch (error) {
            console.error('Erro ao buscar tamanhos para a cor selecionada:', error);
        }
    };

    

    const renderStockBar = (articleId, stock, stock_min, stock_max) => {
        if (stock_min === null || stock_max === null) {
            return <Typography color="error">Preencha o Stock min e max</Typography>;
        }
    
        // Calcula o percentual de estoque em relação ao máximo
        const percentage = Math.min(100, (stock / stock_max) * 100);
    
        // Define a cor da barra com base no percentual de estoque
        let barColor;
        if (percentage < (stock_min / stock_max) * 100) {
            barColor = 'red';
        } else if (percentage < 50) {
            barColor = 'orange';
        } else if (percentage < 75) {
            barColor = 'yellow';
        } else {
            barColor = 'green';
        }
    
        return (
            <LinearProgress
                variant="determinate"
                value={percentage}
                sx={{
                    '& .MuiLinearProgress-bar': {
                        background: `linear-gradient(to right, red, orange, yellow, green)`,
                    },
                    height: 10,
                    backgroundColor: '#e0e0e0', // Cor de fundo
                }}
            />
        );
    };

const saveStockLimits = async (article) => {
    const productId = productIdMap[article.artigo];
    const stockLimit = stockLimits[productId];

    if (productId && stockLimit) {
        try {
            await axios.post(`/api/artigos/${productId}/atualizar_limites/`, stockLimit);
            alert("Estoque mínimo e máximo atualizado com sucesso!");
            // Opcional: recarregar os artigos para atualizar a tabela
            fetchArticlesByColorAndSize(selectedColor, selectedSize);
        } catch (error) {
            console.error("Erro ao salvar limites de estoque:", error);
            alert("Erro ao atualizar estoque mínimo e máximo.");
        }
    } else {
        console.error("IDProduto não encontrado para o artigo:", article.artigo);
    }
};

const handleEditStockLimits = (article) => {
    const productId = productIdMap[article.artigo];
    const min = prompt("Digite o stock mínimo:", stockLimits[productId]?.min || 0);
    const max = prompt("Digite o stock máximo:", stockLimits[productId]?.max || 100);
    setStockLimits(prev => ({ ...prev, [productId]: { min: Number(min), max: Number(max) } }));
}
    

    const handleColorChange = async (event) => {
        const colorName = event.target.value;
        const colorId = colorName === "all" ? "all" : colorIdMap[colorName];
        setSelectedColor(colorName);
        setSelectedSize(''); // Limpa o tamanho selecionado ao mudar a cor
    
        if (colorId === "all") {
            await fetchAllSizes(); // Exibe todos os tamanhos quando "Todas as Cores" for selecionada
        } else {
            await fetchSizesByColor(colorId); // Exibe tamanhos específicos para a cor selecionada
        }
        
        fetchArticlesByColorAndSize(colorId, "all"); // Garante que "all" seja usado como sizeId se aplicável
    };
    
    const handleSizeChange = (event) => {
        const sizeName = event.target.value;
        const sizeId = sizeName === "all" ? "all" : sizeIdMap[sizeName];
        setSelectedSize(sizeName);
        
        // Garante que o selectedColor é válido ao chamar fetchArticlesByColorAndSize
        const colorId = selectedColor === "all" ? "all" : colorIdMap[selectedColor];
        fetchArticlesByColorAndSize(colorId, sizeId);
    };;
    

    return (
        <DashboardLayout>
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
            {/* Botão para redirecionar para a página Warehouse */}
            <Box sx={{ mb: 3 }}>
                    <Button variant="contained" color="primary" onClick={() => navigate('/warehouse')}>
                        Go to Warehouse
                    </Button>
                </Box>
    <Tabs
        value={tabIndex}
        onChange={(event, newValue) => setTabIndex(newValue)}
        sx={{ mb: 3 }}
    >
        <Tab label="Gestão de Stocks" />
        <Tab label="Gestão de Mercadorias" />
    </Tabs>

    {tabIndex === 0 && (
        <>
            <Typography variant="h5" sx={{ mb: 3 }}>Gestão de Stocks</Typography>
            
            {/* Dropdowns para seleção de cor e tamanho */}
            <Paper sx={{ p: 3, mb: 3 }}>
                <Typography variant="h6">Selecione Cor e Tamanho</Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <TextField
                        select
                        label="Cor"
                        value={selectedColor}
                        onChange={handleColorChange}
                        fullWidth
                    >
                        <MenuItem value="all">Todas as Cores</MenuItem>
                        {colors.map((color) => (
                            <MenuItem key={color} value={color}>
                                {color}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        select
                        label="Tamanho"
                        value={selectedSize}
                        onChange={handleSizeChange}
                        fullWidth
                    >
                        {selectedColor !== "all" && (
                            <MenuItem value="all">Todos os Tamanhos</MenuItem>
                        )}
                        {sizes.map((size) => (
                            <MenuItem key={size.id} value={size.nome}>
                                {size.nome}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
            </Paper>

            {/* Tabela de artigos com informações de stock */}
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Artigo</TableCell>
                            <TableCell>Cor</TableCell>
                            <TableCell>Tamanho</TableCell>
                            <TableCell>Stock</TableCell>
                            <TableCell>Nº de Caixas</TableCell>
                            <TableCell>Paletes</TableCell>
                            <TableCell>Gráfico</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {articles.map((article) => (
                            <TableRow key={article.id}>
                                <TableCell>{article.artigo}</TableCell>
                                <TableCell>{article.cor}</TableCell>
                                <TableCell>{article.tamanho}</TableCell>
                                <TableCell>{article.estoque_externo}</TableCell>
                                <TableCell>{article.numero_caixas}</TableCell>
                                <TableCell>{article.paletes}</TableCell>
                                <TableCell>
                                    {renderStockBar(
                                        article.id,
                                        article.estoque_externo,
                                        stockLimits[productIdMap[article.artigo]]?.min ?? article.stock_minimo,
                                        stockLimits[productIdMap[article.artigo]]?.max ?? article.stock_maximo
                                    )}
                                </TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleEditStockLimits(article)}>
                                        <FaEdit />
                                    </IconButton>
                                    <IconButton onClick={() => saveStockLimits(article)}>
                                        Guardar
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )}

    {tabIndex === 1 && <Stockmercadorias />}
</Box>
        </DashboardLayout>
    );
};

export default Stocks;
